// icons/cancer.svg

export const CancerIconV2 = (props) => (
  <svg
    className={props.className}
    width="22"
    height="34"
    viewBox="0 0 22 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 32C12 23 20.3333 2 11 2C1.66667 2 12 26 21 32"
      stroke="#34363E"
      strokeWidth="3"
    />
  </svg>
);
